import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Currency } from "../core/model/currency";
import { CurrencyService } from "../core/service/currency.service";

@Component({
  selector: "app-currency",
  templateUrl: "./currency.component.html",
  styleUrls: ["./currency.component.scss"],
})
export class CurrencyComponent {
  currencies: Currency[];

  constructor(
    private _router: Router,
    private _currencyService: CurrencyService
  ) {}

  ngOnInit() {
    this.getCurrencies();
  }

  getCurrencies() {
    this._currencyService.getAllCurrencies().subscribe(
      (data) => {
        this.currencies = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
